// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3-Yi_","disabled":"FileBtn_disabled__3oWip","warn":"FileBtn_warn__2XmOv","fade":"FileBtn_fade__28q8Q"};